// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vA92z{display:flex;flex-direction:column;gap:16px;padding:24px;max-width:720px;margin:0 auto;width:100%}.vA92z.HQHuG{padding:16px}.Fia6R{width:752px}.ckKz8{width:100%}.KyBAu{gap:0;padding:8px 0}.KyBAu.oQ31y{padding:16px;gap:8px}.lP8sU{padding:8px 16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `vA92z`,
	"contentMobile": `HQHuG`,
	"card": `Fia6R`,
	"cardMobile": `ckKz8`,
	"fieldsCard": `KyBAu`,
	"fieldsCardMobile": `oQ31y`,
	"sheetContent": `lP8sU`
};
export default ___CSS_LOADER_EXPORT___;
